export default __webpack_public_path__ + "images/3b5ed8952738978e65f55edc388946c7-pin.svg";